import { Injectable, signal } from '@angular/core';
import { ISelectedGeography } from '../../shared/interfaces/selected-geography.interface';
import { IClaim } from '../../shared/interfaces/claims.model';

@Injectable({
  providedIn: 'root',
})
export class ClaimStore {
  public selectedGeographies = signal<Array<ISelectedGeography> | null>(null);
  public selectedExpiryDate = signal<Date | null>(null);
  public claims = signal<Array<IClaim> | null>([]);
  public selectedClaims = signal<Array<IClaim> | null>([]);
}
